import React from 'react';

import Page from 'components/page/Page';
import { t } from 'utils/language';
import SignUpSection from '../components/signup/SignUpSection';
import AccessContainer from '../components/access-container/AccessContainer';
import AccessContainerHeader from '../components/access-container/access-container-header/AccessContainerHeader';
import AccessContainerFooter from '../components/access-container/access-container-footer/AccessContainerFooter';

const SignUpPage = () => (
  <Page
    documentTitle={t('signup_page')}
  >
    <AccessContainer type="signup">
      <AccessContainerHeader title={t('signup_header')} />
      <SignUpSection type="none" />
      <AccessContainerFooter
        message={t('signup_footer_has_account')}
        linkText={t('signup_footer_log_in')}
        linkTo="/login"
      />
    </AccessContainer>
  </Page>
);

export default SignUpPage;
